const WORDS = ["Uffici", "Condomini", "Case", "Divani e materassi", "Post-cantiere", "Capannoni", "Reparti produttivi", "Sanificazione", "Pest control", "Pavimenti"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-bold tracking-tight sm:text-7xl ${i % 2 ? "text-stroke" : "text-white"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 fill-[var(--cyan)]"><path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative border-y border-white/10 bg-[#05080F] py-10" data-testid="editorial-marquee">
    <div className="flex overflow-hidden">
      <div className="marquee-track flex">
        <Row />
        <Row hidden />
      </div>
    </div>
  </section>
);
